module.exports = __webpack_public_path__ + "img/home_banner_2.62aa6633.png";